import { AppRouteConfig, breadcrumbs } from '..';
import { PaymentRouteName } from '../payment';

export enum ContactsRouteName {
	contact = 'Contact',
	memberList = 'MemberList',
	volunteerList = 'VolunteerList',
	eventParticipantList = 'EventParticipantList',
	jobParticipantList = 'JobParticipantList',
	allContactList = 'AllContactList',
	contactApplicationList = 'ContactApplicationList',
	mergeContactsList = 'MergeContactsList',
	contactDetails = 'ContactDetails',
	mergeContactDetails = 'MergeContactDetails',
	contactApplicationDetails = 'ContactApplicationDetails',
	newContact = 'NewContact',
	newMember = 'NewMember',
	newVolunteer = 'NewVolunteer',
	caseProfileList = 'CaseProfileList',
	newCaseProfile = 'NewCaseProfile',
	donationProfileList = 'DonationProfileList',
}

export function contactsRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'members',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ContactsRouteName.memberList,
					component: () =>
						import('../../views/contact/MemberContactProfileList.vue'),
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('members')],
						caslSubject: 'contacts.member',
						caslAction: 'view',
						feature: 'contacts.member',
						maskFeature: ['contacts'],
					},
				},
				{
					path: 'new',
					name: ContactsRouteName.newMember,
					component: () => import('../../views/contact/NewContact.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('members'),
							breadcrumbs.get('newMember'),
						],
						dynamicFrom: 1,
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'volunteers',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ContactsRouteName.volunteerList,
					component: () => import('../../views/contact/VolunteerList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('volunteers'),
						],
						caslSubject: 'contacts.volunteer',
						caslAction: 'view',
						feature: 'contacts.volunteer',
						maskFeature: ['contacts'],
					},
				},
				{
					path: 'new',
					name: ContactsRouteName.newVolunteer,
					component: () => import('../../views/contact/NewContact.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('volunteers'),
							breadcrumbs.get('newVolunteer'),
						],
						dynamicFrom: 1,
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'cases',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ContactsRouteName.caseProfileList,
					component: () => import('../../views/contact/CaseProfileList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contactCase'),
						],
						caslSubject: 'contacts.case',
						caslAction: 'view',
						feature: 'contacts.case',
						maskFeature: ['contacts'],
					},
				},
				{
					path: 'new',
					name: ContactsRouteName.newCaseProfile,
					component: () => import('../../views/contact/CaseProfileList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contactCase'),
							breadcrumbs.get('newContactCase'),
						],
						dynamicFrom: 1,
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'donors',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ContactsRouteName.donationProfileList,
					component: () => import('../../views/contact/DonationProfileList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contactDonor'),
						],
						caslSubject: 'contacts.donor',
						caslAction: 'view',
						feature: 'contacts.donor',
						maskFeature: ['contacts'],
					},
				},
			],
		},
		{
			path: 'all',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ContactsRouteName.allContactList,
					component: () => import('../../views/contact/ContactList.vue'),
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('contacts')],
						caslSubject: 'contacts.all',
						caslAction: 'view',
						maskFeature: ['contacts'],
					},
				},
				{
					path: 'new',
					name: ContactsRouteName.newContact,
					component: () => import('../../views/contact/NewContact.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contacts'),
							breadcrumbs.get('newContact'),
						],
						dynamicFrom: 1,
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'participants',
			name: ContactsRouteName.eventParticipantList,
			component: () => import('../../views/contact/EventParticipantList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('eventParticipants'),
				],
				caslSubject: 'contacts.participant', //permission name can't be eventParticipant, need to patch BE DB
				caslAction: 'view',
				maskFeature: ['contacts', 'events'],
			},
		},
		{
			path: 'job-participants',
			name: ContactsRouteName.jobParticipantList,
			component: () => import('../../views/contact/JobParticipantList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('jobParticipants'),
				],
				caslSubject: 'contacts.jobParticipant',
				caslAction: 'view',
				maskFeature: ['contacts', 'jobs'],
			},
		},
		{
			path: ':contactId/applications',
			name: ContactsRouteName.contactApplicationList,
			component: () => import('../../views/contact/ContactApplicationList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('contacts'),
					breadcrumbs.get('applications'),
				],
				caslSubject: 'contacts.applications',
				caslAction: 'view',
				feature: 'contacts.applications',
				calledFrom: 'contacts',
			},
		},
		{
			path: 'applications',
			name: ContactsRouteName.contactApplicationList,
			component: () => import('../../views/contact/ContactApplicationList.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('applications')],
				caslSubject: 'contacts.applications',
				caslAction: 'view',
				feature: 'contacts.applications',
				maskFeature: ['contacts'],
			},
		},
		{
			//duplicated for proper breadcrumbs
			path: ':contactId/applications/:id',
			name: ContactsRouteName.contactApplicationDetails,
			component: () => import('../../views/contact/ContactApplication.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('contacts'),
					breadcrumbs.get('applications'),
					breadcrumbs.get('contactApplicationDetails'),
				],
				caslSubject: 'contacts.applications',
				caslAction: 'view',
				calledFrom: 'contacts',
			},
		},
		{
			//duplicated for proper breadcrumbs
			path: ':contactId/payments',
			name: PaymentRouteName.allPaymentList,
			component: () => import('../../views/payment/AllPayments.vue'),
			props: { online: null },
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('contacts'),
					breadcrumbs.get('allPayments'),
				],
				caslSubject: 'payments.all_payment',
				caslAction: 'view',
				calledFrom: 'contacts',
			},
		},
		{
			//duplicated for proper breadcrumbs
			path: ':contactId/payments/details/:id',
			name: PaymentRouteName.paymentDetails,
			component: () => import('../../views/payment/PaymentDetails.vue'),
			props: { online: null },
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('contacts'),
					breadcrumbs.get('allPayments'),
					breadcrumbs.get('paymentDetails'),
				],
				caslSubject: 'payments.all_payment',
				caslAction: 'view',
				calledFrom: 'contacts',
			},
		},

		{
			path: 'merge',
			component: { render: c => c('router-view') },
			meta: {
				dynamicFrom: 1,
				caslSubject: 'contacts.all',
				caslAction: 'view',
			},
			children: [
				{
					path: '',
					name: ContactsRouteName.mergeContactsList,
					component: () => import('../../views/contact/MergeContactsList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contacts'),
							breadcrumbs.get('merge'),
						],
					},
				},
				{
					path: 'detail/:id',
					name: ContactsRouteName.mergeContactDetails,
					component: () => import('../../views/contact/ContactDetails.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('contacts'),
							breadcrumbs.get('merge'),
							breadcrumbs.get('contactDetail'),
						],
						dynamicFrom: 1,
					},
				},
			],
		},
		{
			path: 'detail/:id',
			name: ContactsRouteName.contactDetails,
			component: () => import('../../views/contact/ContactDetails.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('contacts'),
					breadcrumbs.get('contactDetail'),
				],
				dynamicFrom: 1,
			},
		},
		{
			path: 'applications/:id',
			name: ContactsRouteName.contactApplicationDetails,
			component: () => import('../../views/contact/ContactApplication.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('applications'),
					breadcrumbs.get('contactApplicationDetails'),
				],
				caslSubject: 'contacts.applications',
				caslAction: 'view',
			},
		},
	];
}
